import { render, staticRenderFns } from "./DetailExtranet.vue?vue&type=template&id=450c3fda&scoped=true"
import script from "./DetailExtranet.vue?vue&type=script&lang=js"
export * from "./DetailExtranet.vue?vue&type=script&lang=js"
import style0 from "./DetailExtranet.vue?vue&type=style&index=0&id=450c3fda&prod&lang=css"
import style1 from "./DetailExtranet.vue?vue&type=style&index=1&id=450c3fda&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c3fda",
  null
  
)

export default component.exports